
import React, { useState, useContext,useEffect } from "react";
import * as Config from "../constants/Config";
import { useNavigate, Link } from "react-router-dom";

import { contentContext } from "../context/contentContext";
let { lambda, appname } = window.app

const NotFound = () => {
    const { userData } = useContext(contentContext);
    const [image, setImg] = useState('');
    const navigate = useNavigate();
    // const handleBack = () => {
    //     navigate('/')
    // }
  useEffect(() => {
 
     if (window.site === undefined) {
       setTimeout(() => {
         if (window.site && window.site.common && window.site.common.imageCloudfront) {
           setImg(window.site.common.imageCloudfront)
         }
       }, 1000);
     }
     if (window.site && window.site.common && window.site.common.imageCloudfront) {
       setImg(window.site.common.imageCloudfront)
     }
 
 
 
   }, [window.site]);
    const handleBack = () => {
        let userArr = userData.permissions

        console.log("userArr",userData)

                const obj = userArr?.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                let k = userData

                let permissionList = userData && userData.permissions
                let filterdList = permissionList.filter((item) => item.display===true)
                let id = filterdList && filterdList[0] && filterdList[0].menu.split(" ").join("").toLowerCase()

                navigate("/" + id);
      }

    return (
        <>
            <main className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <div className="text-center p-4 rounded-circle shadow" style={{ width: '400px', height: '400px', backgroundColor: '#fff6' }}>
                    <div className="d-flex flex-column justify-content-center align-items-center h-100">
                        <img
                            src={ `${image}${appname}/images/web/Comming-soon-graphic.svg`}
                            alt="Coming soon"
                            className="img-fluid mb-3"
                            style={{ maxWidth: '220px' }}
                        />
                        <h3 className="fw-bold text-dark mb-1">Coming Up</h3>
                        <p className="text-muted mb-0">Stay tuned with us!</p>
                        <button
                            className="stroke-btn-style mt-3 d-block mx-auto"
                            onClick={handleBack}
                        >
                            BACK TO HOME
                        </button>
                    </div>
                </div>
            </main>
           


        </>
    );
};

export default NotFound;
